// TODO: This doesn't lives here
export const MAX_CONTENT_WIDTH = 800;
export const MAX_FORM_WIDTH = 500;

// Delivery time for gift cards
export const GIFT_CARD_DELIVERY_TIME = '7am AEST';
export const GIFT_CARD_DELIVERY_HELPER_TEXT = `Emails are sent from ${GIFT_CARD_DELIVERY_TIME} on the selected date.`;
export const GIFT_CARD_DELIVERY_IMMEDIATE_TEXT = 'The Gift Card will be sent immediately.';
